import { api } from 'api'
import { WorkerProfileShift } from './workerProfile'
import { path } from 'ramda'

export interface WorkForCompany {
  status: string
  shift: WorkerProfileShift
  e2wReview?: {
    rating?: number
  }
}

export async function getWorkerShiftsForCompany(workerId: number) {
  const data = await api.post(
    '/company/graphql_dispatch/worker_shifts_90b97c86',
    {
      workerId,
    }
  )

  return path(
    ['data', 'data', 'company', 'worker', 'workForCompany'],
    data
  ) as WorkForCompany[]
}
